var _g, _path, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTwitterBlack(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 34,
    viewBox: "0 0 35 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_442_4860)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24.6497 13.3338C24.6612 13.4937 24.6612 13.6536 24.6612 13.8135C24.6612 18.6904 20.9493 24.3097 14.165 24.3097C12.0749 24.3097 10.1333 23.7043 8.5 22.6536C8.79696 22.6879 9.08247 22.6993 9.39086 22.6993C11.1154 22.6993 12.703 22.1168 13.9708 21.1232C12.349 21.0889 10.9898 20.0267 10.5216 18.5648C10.75 18.599 10.9784 18.6219 11.2183 18.6219C11.5495 18.6219 11.8807 18.5762 12.1891 18.4963C10.4987 18.1536 9.23093 16.6688 9.23093 14.8757V14.83C9.72203 15.1041 10.2931 15.2755 10.8984 15.2983C9.90477 14.6358 9.25379 13.5051 9.25379 12.2259C9.25379 11.5407 9.43649 10.9125 9.75631 10.3643C11.5723 12.6028 14.302 14.0647 17.3629 14.2247C17.3058 13.9506 17.2715 13.6651 17.2715 13.3795C17.2715 11.3465 18.9162 9.69043 20.9606 9.69043C22.0228 9.69043 22.9822 10.1359 23.656 10.8554C24.4898 10.6955 25.2893 10.3871 25.9974 9.96454C25.7233 10.8212 25.1408 11.5407 24.3756 11.9975C25.118 11.9176 25.8375 11.712 26.4999 11.4265C25.9975 12.1574 25.3693 12.8084 24.6497 13.3338Z",
    fill: "#1c1c1c"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M34.5 17C34.5 26.3888 26.8888 34 17.5 34C8.11116 34 0.5 26.3888 0.5 17C0.5 7.61116 8.11116 0 17.5 0C26.8888 0 34.5 7.61116 34.5 17ZM1.35 17C1.35 25.9194 8.5806 33.15 17.5 33.15C26.4194 33.15 33.65 25.9194 33.65 17C33.65 8.0806 26.4194 0.85 17.5 0.85C8.5806 0.85 1.35 8.0806 1.35 17Z",
    fill: "#1c1c1c"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_442_4860"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "#1c1c1c",
    transform: "translate(8.5 8)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitterBlack);
export default __webpack_public_path__ + "static/media/twitter-black.981583446d0aa2360a38d1cc1649f053.svg";
export { ForwardRef as ReactComponent };